import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-group-statistic',
  templateUrl: './statistic.component.html',
  styleUrls: ['./statistic.component.scss'],
})
export class StatisticComponent  implements OnInit {

  @Input() title: string = '_';
  @Input() score: string = '_';
  @Input() attendance: string = '_';
  @Input() missedLessons: number|string ='_';
  @Input() totalLessons: number|string = '_';
  @Input() complete: string = '_';
  @Input() tests: string = '_';
  @Input() result: string = '_';

  @Input() selfStudy: number|string = '_';
  @Input() completedSS: number|string = '_';
  @Input() totalSS: number|string = '_';

  @Input() passedExams: number|string = '_';
  @Input() passedExamsMarkAvg: number|string = '_';
  @Input() totalExams: number|string = '_';
  @Input() maxMark: number|string = '_';
  @Input() finalExam: number|string = '_';


  constructor() { }

  ngOnInit() {

  }

}
